document.addEventListener("DOMContentLoaded", function() {
    const ratingWrap = document.querySelector('.jdgm-rev-widg__summary-stars');
    if (!ratingWrap) return;

    const ratingText = ratingWrap.querySelector('.jdgm-rev-widg__summary-average');
    if (!ratingText) return;

    const ratingValue = ratingText.textContent.trim(); // example: "5.00 out of 5"

    // Set value as custom attribute
    ratingWrap.setAttribute("data-rating-value", ratingValue);
});

document.querySelectorAll('header-menu details').forEach((detail) => {
  let timeout;

  detail.addEventListener('mouseenter', () => {
    clearTimeout(timeout);
    detail.setAttribute('open', '');
  });

  detail.addEventListener('mouseleave', () => {
    timeout = setTimeout(() => {
      detail.removeAttribute('open');
    }, 150);
  });
});